import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import type { ApiImage } from '../lib/media';
import { imageSrc } from '../lib/media';
import { openPhotos } from '../lib/photos';
import styles from './ui.module.css';

/**
 * Отметка «снимок есть» прямо в строке фактов: значок, подпись и просмотр на
 * весь экран по нажатию.
 *
 * Нужна там, где у вещи ВТОРОЙ снимок, а места под вторую миниатюру нет:
 * паспорт питомца. Словом «паспорт» в общем ряду фактов это выглядело как
 * справка о том, что бумага существует, — а посмотреть её было негде вовсе,
 * когда у питомца нет собственного фото.
 */
export function ImageMark({ image, children }: { image: ApiImage; children: ReactNode }) {
  const full = imageSrc(image, 'full');
  if (full === undefined) return null;

  return (
    <button
      type="button"
      className={clsx(styles.reset, styles.imageMark)}
      onClick={() => openPhotos([full], 0)}
    >
      {children}
    </button>
  );
}
